import React, { Fragment } from 'react';
import { Row, Col, Button } from 'react-bootstrap';

const LabeledQuestion = ({ index, question, handleOptionSelected }) => {
  const options = JSON.parse(question.options);

  return (
    <Fragment>
      <h5 className='my-3'>{`${index}. ${question.title}`}</h5>
      <Row className='justify-content-center'>
        <Col xs={6} className='text-left'>
          {question.label_left}
        </Col>
        <Col xs={6} className='text-right'>
          {question.label_right}
        </Col>
      </Row>
      {/* <Col className='pl-0'> */}
      <Row className='justify-content-between no-gutters'>
        {options.map((o) => (
          <Col xs={1} key={o.index}>
            <Button
              block
              className='my-2'
              variant='outline-secondary'
              onClick={(e) => handleOptionSelected(e, o.index)}
            >
              {o.label}
            </Button>
          </Col>
        ))}
      </Row>
      {/* </Col> */}
      {/* <Col xs={12} md={3} className='d-none d-md-flex  text-right'>
          {answer.labels.right}
        </Col> */}
      {/* </Row> */}
    </Fragment>
  );
};

export default LabeledQuestion;
